// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"556":"2ec09b95","853":"7d71d3c2"}[chunkId] + ".chunk.css";
};